// extracted by css-extract-rspack-plugin
export default {"currencyInputWrapper":"UpdateDonationAmountModal_currencyInputWrapper__VmQxu","danger":"UpdateDonationAmountModal_danger__RbIaZ"};